<!-- <app-header></app-header> -->
<!-- <app-home></app-home>
<app-footer></app-footer> -->

<router-outlet (activate)="onActivate($event)"></router-outlet>
